<script lang="ts" setup>
import { useLocalStorage, useMediaQuery } from '@vueuse/core';
import ModalDialogV2 from './ModalDialogV2.vue';

const wasClosed = useLocalStorage('mobile-alert-modal-closed', false);
const isMobile = useMediaQuery('(max-width: 768px)');
const { t } = useTranslations();

const showModal = computed(() => {
  if (wasClosed.value) return false;
  if (!isMobile.value) return false;
  return true;
});
</script>

<template>
  <ModalDialogV2
    v-model="showModal"
    :title="t('mobile_alert.title')"
    :description="t('mobile_alert.description')"
    type="info"
    icon="material-symbols:mobile-alert-outline"
    :show-cancel-button="false"
    :confirm-button-text="t('mobile_alert.button')"
    static
    @confirm="wasClosed = true"
  >
    <template #default>
      <p class="text-sm">{{ t('mobile_alert.content') }}</p>
    </template>
  </ModalDialogV2>
</template>
